import { OnMessageCallback } from 'mqtt';
import { store } from '../../app/store';
import { missionActions } from './missionSlice';

export const missionMqttParser: OnMessageCallback = (topic: any, payload: any, packet: any): void => {
    store.dispatch(missionActions.new_mission_message({...JSON.parse(payload.toString())}));
};